import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import React__default, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { IlIconInitializer, IlToastContainer, IlLoading, toast } from 'il-framework-component';
import { SwitchIdentityModal } from '../SwitchIdentityModal/SwitchIdentityModal.js';
import { getAllListIdentities } from '../APIRequets.js';

function SwitchIdentityContainer(_ref) {
  var showSwitchIdentityModal = _ref.showSwitchIdentityModal,
    applicationId = _ref.applicationId,
    _onCloseCallback = _ref.onCloseCallback,
    hostUrl = _ref.hostUrl;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    switchIdentitiesList = _useState2[0],
    setSwitchIdentitiesList = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    displayModal = _useState4[0],
    setDisplayModal = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showLoading = _useState6[0],
    setShowLoading = _useState6[1];
  var DisplayToast = function DisplayToast(errorMessage) {
    return toast({
      title: errorMessage,
      notificationType: 'toast',
      kind: 'error'
    });
  };
  useEffect(function () {
    _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var listIdentities;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setShowLoading(true);
            _context.prev = 1;
            _context.next = 4;
            return getAllListIdentities(hostUrl);
          case 4:
            listIdentities = _context.sent;
            setShowLoading(false);
            if (listIdentities && listIdentities.length === 0) {
              DisplayToast('You dont have any linked Identities.');
            }
            setSwitchIdentitiesList(listIdentities);
            _context.next = 16;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            setShowLoading(false);
            DisplayToast('Unexpected error occurred. Please try again later.');
            _onCloseCallback();
            throw _context.t0;
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 10]]);
    }))();
    setDisplayModal(true);
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "switch-identityContainer"
  }, /*#__PURE__*/React__default.createElement(IlIconInitializer, null), /*#__PURE__*/React__default.createElement(IlToastContainer, {
    position: "top-center"
  }), showLoading && /*#__PURE__*/React__default.createElement(IlLoading, {
    active: true,
    withOverlay: true
  }), showSwitchIdentityModal && displayModal && switchIdentitiesList.length > 0 && /*#__PURE__*/React__default.createElement(SwitchIdentityModal, {
    showSwitchIdentityModal: showSwitchIdentityModal,
    applicationId: applicationId,
    listIdentities: switchIdentitiesList,
    onCloseCallback: function onCloseCallback() {
      return _onCloseCallback();
    },
    hostUrl: hostUrl
  }));
}
SwitchIdentityContainer.propTypes = {
  showSwitchIdentityModal: PropTypes.bool.isRequired,
  applicationId: PropTypes.string,
  onCloseCallback: PropTypes.func,
  hostUrl: PropTypes.string
};
SwitchIdentityContainer.defaultProps = {
  applicationId: ''
};

export { SwitchIdentityContainer };
